import { Link as RouterLink } from 'react-router-dom'
import { Link, Stack, Typography } from '@mui/material'
import { platformAdminRoutes } from 'router/routes'
import { LuminaTeam } from './services'

interface Props {
  processes: LuminaTeam['source_processes']
}

const TeamSourceProcesses = ({ processes }: Props) => {
  if (!processes?.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        Creación manual
      </Typography>
    )
  }

  return (
    <Stack spacing={0.5}>
      {processes.map((process) => (
        <Link
          key={process.id}
          component={RouterLink}
          to={`${platformAdminRoutes.DetailProcessDelivered}?processId=${process.id}`}
          state={{ id: process.id }}
          aria-label={`Abrir proceso ${process.name}`}
          underline="hover"
          sx={{ color: '#2d749c', fontWeight: 600, overflowWrap: 'anywhere' }}
        >
          {process.name}
        </Link>
      ))}
    </Stack>
  )
}

export default TeamSourceProcesses
